<section class="cmn-innerpage-wrapper quotation">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <div class="form-wrapper">
      <h6 class="">Filter <span (click)="clearFilter()">Clear All</span></h6>
      <form [formGroup]="dateRangeForm">
        <mat-form-field>
          <mat-date-range-input
            [rangePicker]="picker"
            [dateFilter]="dateFilter"
          >
            <input
              matStartDate
              placeholder="Start date"
              formControlName="startDate"
              (dateInput)="onDateChange($event, 'start')"
            />
            <input
              matEndDate
              placeholder="End date"
              formControlName="endDate"
              (dateInput)="onDateChange($event, 'end')"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </form>
    </div>
    <button
      class="cmn-add-btn"
      (click)="navigateTo('/quotation/quotation-new')"
      *ngIf="canCreateQuotation$ | async"
    >
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New
      Quotation
    </button>
    <div
      [ngClass]="{ show: isDropdownOpen }"
      class="common-dropdown filter-position"
      #dropdown
    >
      <button class="close-dropdown" (click)="toggleDropdown($event)"></button>
      <form>
        <h6 class="cmn-popup-heading">Filter <span>Clear All</span></h6>
        <div class="filter-inner-content">
          <h2>Branch</h2>
          <div class="check-wrapper">
            <div class="check-box">
              <label class="checkbox-wrapper">
                <input type="checkbox" />
                test
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="cmn-apply-btn" type="submit">Apply</button>
        </div>
      </form>
    </div>
    <!-- Filter -->
  </div>
  <div class="sub-head">
    <div class="head-box total-box" (click)="fetchParents()">
      <img src="assets/images/icons/icon-total.svg" alt="Total" />
      <div>
        <h2>Total</h2>
        <h5>{{ quotesDashboardData?.totalQuotes }}</h5>
      </div>
    </div>
    <div class="head-box total-box" (click)="fetchParents('Draft')">
      <img src="assets/images/icons/icon-draft.svg" alt="Draft" />
      <div>
        <h2>Draft</h2>
        <h5>{{ quotesDashboardData?.draftQuotes }}</h5>
      </div>
    </div>
    <div class="head-box total-box" (click)="fetchParents('Pending')">
      <img src="assets/images/icons/icon-open.svg" alt="Pending" />
      <div>
        <h2>Pending</h2>
        <h5>{{ quotesDashboardData?.pendingQuotes }}</h5>
      </div>
    </div>
    <div class="head-box total-box" (click)="fetchParents('Approved')">
      <img src="assets/images/icons/icon-confirmed.svg" alt="Confirmed" />
      <div>
        <h2>Approved</h2>
        <h5>{{ quotesDashboardData?.approvedQuotes }}</h5>
      </div>
    </div>
    <div class="head-box total-box" (click)="fetchParents('Accepted')">
      <img src="assets/images/icons/icon-confirmed.svg" alt="Confirmed" />
      <div>
        <h2>Accepted</h2>
        <h5>{{ quotesDashboardData?.acceptedQuotes }}</h5>
      </div>
    </div>
  </div>
  <div class="inner-content">
    <ag-grid-angular
      style="width: 100%"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [class]="themeClass"
      (cellClicked)="onCellClicked($event)"
    />
  </div>
  <div class="pagination-wrapper">
    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select
        id="pageSize"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange($event)"
      >
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="page-nav" *ngIf="totalPages > 1">
      <button class="prev" (click)="prevPage()" [disabled]="page === 0">
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="prev arrow"
          srcset=""
        />
      </button>
      <span> Page {{ page + 1 }} of {{ totalPages }} </span>
      <button
        class="next"
        (click)="nextPage()"
        [disabled]="page + 1 >= totalPages"
      >
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="next arrow"
          srcset=""
        />
      </button>
    </div>
  </div>
</section>
